import { render, staticRenderFns } from "./NewTableItem.vue?vue&type=template&id=6ba551a0&scoped=true"
import script from "./NewTableItem.vue?vue&type=script&lang=js"
export * from "./NewTableItem.vue?vue&type=script&lang=js"
import style0 from "./NewTableItem.vue?vue&type=style&index=0&id=6ba551a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba551a0",
  null
  
)

export default component.exports